
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'

import '../report.css'
// import { connect } from 'react-redux';

class ReportCommissionMechanic extends Component {
  constructor(props) {
    super(props)
    const WHOLE_YEAR = momentHelper.getMonth() //'00'

    this.state = {
      loading:false,
      activePage: 1,
      empId: '',
      empList: [],
      month: WHOLE_YEAR,
      year: momentHelper.getYear(),
      data: [],
      dataDetail: [],
      isRange: false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      showDetail:undefined
    }
    this.refTableId = 'ReportCommissionMechanic-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day,this.state.empId)
      this.loadMechaniclist(this.state.year,this.state.month)
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary() {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total = total + (item.amount==''||item.amount==null||item.amount==undefined||isNaN(item.amount)?0:parseFloat(item.amount))
    }) 
    return total
  }

  loadMechaniclist(year,month) {
    let empList = []
    empList.push({label:'เลือกทั้งหมด',value:''})
    ReportStore.loadMechaniclist(year,month,(result)=>{
        result.data.forEach((item)=>{
            empList.push({
                label:item.first_name+' '+item.last_name,
                value:item.employee_id
            })
        })
        this.setState({empList:empList})
    })
  }

  loadData(year='',month='',day='',empId='') {
    this.setState({loading:true})  
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadReportCommissionMechanic(year,month,day,empId,(result)=>{
      this.setState({loading:false,data:result.data,dataDetail:[],showDetail:undefined})
    })
  }

  loadDataRange(start='',end='',empId='') {
    ReportStore.loadReportCommissionMechanicRange(start,end,empId,(result)=>{
      this.setState({loading:false,data:result.data,dataDetail:[],showDetail:undefined})
    })
  }

  onShowDetailClick(item) {
    let {year,month,showDetail} = this.state
    if (showDetail!=undefined&&showDetail==item.employee_id)
      showDetail = undefined
    else
      showDetail = item.employee_id 

    this.setState({loading:true,showDetail:showDetail})
    if (showDetail!=undefined) {
      ReportStore.loadMechanicDetail(year,month,item.employee_id,item.work_no,item.task_value,(result)=>{
        this.setState({loading:false,dataDetail:result.data})
      })
    } else {
      this.setState({loading:false})
    }
  }

  renderRowTitleDetail() {
    let {dataDetail} = this.state
    if (dataDetail.length==0) {
      return('')
    } else {
      return(
        <tr key='s-1'>
          <td colSpan={4}></td>
          <td className='text-center' style={{backgroundColor:'#5D7BAC',color:'#fff'}}>รายละเอียด</td>
          <td className='text-center' style={{backgroundColor:'#5D7BAC',color:'#fff'}}>รหัสซ่อม</td>
          <td className='text-center' style={{backgroundColor:'#5D7BAC',color:'#fff'}}>ค่าแรง</td>
          <td className='text-center' style={{backgroundColor:'#5D7BAC',color:'#fff',width:'75px'}}>เรทส่วนแบ่ง</td>
          <td className='text-center' style={{backgroundColor:'#5D7BAC',color:'#fff',width:'75px'}}>ส่วนแบ่ง</td>
        </tr>
      )
    }
  }

  renderRowDetail() {
    let {dataDetail} = this.state
    if (dataDetail.length==0) {
      return(<tr key='s0'><td className='text-center' colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        dataDetail.map((item,index)=>{
          return(
            <tr key={'s'+index}>
              <td colSpan={4}></td>
              <td className='text-center'>{item.detail}</td>
              <td className='text-center'>{item.fixlevel}</td>
              <td className='text-right'>{this.getNumberFormat(item.wage_cost)}</td>
              <td className='text-right' style={{width:'75px'}}>{this.getNumberFormat(item.commission_rate)}</td>
              <td className='text-right' style={{width:'75px'}}>{this.getNumberFormat(item.commission_amount)}</td>
            </tr>
          )
        })
      )
    }
  }

  renderBody() {
    let {data,showDetail,dataDetail} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>
          [
            <tr key={'m'+index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.employee_id}</td>
              <td className='text-center'>{item.employee_name}</td>
              <td className='text-center'>{item.task_name}&nbsp;<Button bsSize='xs' bsStyle='default' onClick={this.onShowDetailClick.bind(this,item)}><FontAwesome name='search' /></Button></td>
              <td className='text-center'>{item.task_quantity}</td>
              <td className='text-right' colSpan={showDetail!=undefined&&dataDetail.length>0?2:1}>{this.getNumberFormat(item.amount)}</td>
            </tr>,
            showDetail==item.employee_id?this.renderRowTitleDetail():'',
            showDetail==item.employee_id?this.renderRowDetail():''
          ]
        )
      )
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00') {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00') {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00') {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
    let {showDetail,dataDetail} = this.state
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid table-report-kkc-income'>
          <thead>
            <tr>
              <th style={{display:'none'}} colSpan={8}>รายงานสรุปส่วนแบ่งผลการปฏิบัติงานของพนักงาน {this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'100px'}}>ใบงานเลขที่</th>
              <th className='text-center' style={{width:'120px'}}>ทะเบียนรถ</th>
              <th className='text-center' style={{width:'100px'}}>รหัสพนักงาน</th>
              <th className='text-center' style={{width:'200px'}}>ชื่อพนักงาน</th>
              <th className='text-center' style={{width:'100px'}}>งาน</th>
              <th className='text-center' style={{width:'100px'}}>จำนวนชิ้น</th>
              <th className='text-center' style={{width:'150px'}} colSpan={showDetail!=undefined&&dataDetail.length>0?2:1}>ส่วนแบ่ง</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th className='text-right' colSpan={7}>รวมส่วนแบ่ง</th>
              <th className='text-right' colSpan={showDetail!=undefined&&dataDetail.length>0?2:1}>{this.getNumberFormat(this.getSummary())}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value,this.state.empId)
    this.loadMechaniclist(this.state.year,this.state.month)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadData(this.state.year,val.value,_day,this.state.empId)
    this.loadMechaniclist(this.state.year,val.value)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadData(val.value,this.state.month,_day,this.state.empId)
    this.loadMechaniclist(val.value,this.state.month)
  }

  onEmpChange(val) {
    this.setState({
      empId: val.value, isRange: false
    })
    this.loadData(this.state.year,this.state.month,this.state.day,val.value)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานสรุปส่วนแบ่งผลการปฏิบัติงานของพนักงาน.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportCommissionMechanic&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&empId='+this.state.empId+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportCommissionMechanic&start_date='+start+'&end_date='+end+'&empId='+this.state.empId+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day,this.state.empId)
      this.loadMechaniclist(_year,_month)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.empId)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end,this.state.empId)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?this.state.dayRange:this.state.day)+'/'+this.state.month+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }    

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{display:'inline-flex',verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        <div style={{ width: '200px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.empId}
            options={this.state.empList}
            onChange={this.onEmpChange.bind(this)}
          />
        </div>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.empId)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const reportName = 'สรุปส่วนแบ่งผลการปฏิบัติงานของพนักงาน'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/* this.renderPaging() */}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportCommissionMechanic.defaultProps = {
  show : false
}

export default ReportCommissionMechanic;





// WEBPACK FOOTER //
// ./src/view/report/employee/ReportCommissionMechanic.js